import './App.css';
import Home from './pages/Home/Home/Home';
import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ProjectDetail from './pages/ProjectDetail/ProjectDetail';
import About from './pages/About/About/About';
import Contact from './pages/Contact/Contact/Contact';
import Blogs from './pages/Blogs/Blogs/Blogs';
import AllProjects from './pages/AllProjects/AllProjects';
import NotFound from './pages/Home/NotFound/NotFound';
import Skills from './pages/Skills/Skills';
import { AppContextProvider } from './contexts/AppContext';

function App() {
  return (
    <AppContextProvider>
      <div className='App'>
        <Router>
          <Switch>
            <Route exact path='/'>
              <Home></Home>
            </Route>
            <Route exact path='/home'>
              <Home></Home>
            </Route>

            <Route path='/projectDetail/:id'>
              <ProjectDetail></ProjectDetail>
            </Route>

            <Route exact path='/about'>
              <About></About>
            </Route>

            <Route exact path='/contact'>
              <Contact></Contact>
            </Route>

            <Route exact path='/blogs'>
              <Blogs></Blogs>
            </Route>

            <Route path='/allProjects'>
              <AllProjects></AllProjects>
            </Route>

            <Route path='/skills'>
              <Skills></Skills>
            </Route>

            <Route path='*'>
              <NotFound></NotFound>
            </Route>
          </Switch>
        </Router>
      </div>
    </AppContextProvider>
  );
}

export default App;
